import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'

import { sectionSubtitle, mediaMax } from '@/styles/mixins'

import { LinkLabel } from '@/components/Link/style'

export const BgContainer = styled.div`
  width: 100vw;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  overflow: hidden;
`

export const NameLabel = styled.span`
  font-size: 13rem;
  font-family: ${({ theme }) => theme.fonts.serif};
  color: ${({ theme }) => theme.colors.lightGrey};
  text-align: center;
  top: 10vh;
  left: -10vw;
  position: absolute;
  text-transform: uppercase;
  width: 120vw;
  clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
  opacity: .1;
`

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  align-items: center;
  transform: translate(-50%, -50%);
  position: static;
  display: flex;
  flex-direction: column;
  transform: none;
`

export const CircleWrapper = styled(Wrapper)`
  position: absolute;
  top: 5vh;
  transform: none;
`

export const ArtContainer = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const Circle = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32vh;
  height: 32vh;
  background-color: ${({ color }) => color};
  border-radius: 50%;
  z-index: -99999;
  transition: opacity ease 1s .5s;
`

export const ArtCircle = styled(Circle)`
  background-image: url(${({ image }) => image});
  background-position: 50% 50%;
  background-size: 95%;
  background-repeat: repeat;
  opacity: 0;
  /* transition: opacity ease 1s .5s, background-position ease .8s; */
  clip-path: circle(0.0% at 50% 50%);
`

const ArtCircleEnterAnimation = keyframes`
  from {
    clip-path: circle(0.0% at 50% 50%);
  }

  to {
    clip-path: circle(100.0% at 50% 50%);
  }
`

const ArtCircleLeaveAnimation = keyframes`
  from {
    clip-path: circle(100.0% at 50% 50%);
  }

  to {
    clip-path: circle(0.0% at 50% 50%);
  }
`

export const ImageBaseWrapper = styled.div`
  height: 48vh;
  max-height: 400px;
  width: auto;
  transform-origin: 100vw center;
  ${mediaMax.xs}{
    transform-origin: center;
  }
`

export const ImageRotationWrapper = styled.div`
  width: 100%;
  height: 100%;
  transform: rotate(12deg);
  transition: transform 1.2s ease;
`

export const ImageParallaxWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const Image = styled.img`
  width: auto;
  height: 100%;
  display: block;
`

export const TextContainer = styled.div`
  width: 50%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding: unset;
  box-sizing: content-box;
  ${mediaMax.xs}{
    margin-top: 6rem;
    width: 100%;
  }
`

export const Label = styled.h1`
  ${sectionSubtitle()};
  text-transform: uppercase;
  font-size: .8rem;
  color: ${({ theme }) => theme.colors.lightGreen2};
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  width: 90%;
  margin: auto;
`

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.serif};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.brown};
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  width: 90%;
  font-size: 3.5rem;
  margin: 1.6rem auto;
`

export const Text = styled.p`
  width: 90%;
  font-family: ${({ theme }) => theme.fonts.sansSerif};
  font-size: 1.4rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.colors.grey};
  margin: auto;
  margin-bottom: 80px;
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
`

export const Actions = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  gap: 5rem;
`

export const Action = styled.div`
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  margin: 0;
  width: 100%;
  ${LinkLabel}{
    display: none;
    &:after{
      height: 10px;
    }
  }
`

// export const Link = styled.a`
//   text-decoration: none;
//   font-size: 1.4rem;
//   text-transform: uppercase;
//   font-family: ${({ theme }) => theme.fonts.sansSerif};
//   color: ${({ theme }) => theme.colors.lightGreen2};
//   position: relative;
//   cursor: pointer;
//   height: auto;
//   padding-bottom: 2px;
//   &:after {
//     content: '';
//     display: block;
//     height: 3px;
//     width: 100%;
//     background-color: ${({ theme }) => theme.colors.grey};
//     position: absolute;
//     bottom: -2px;
//     left: 0;
//   }
// `

const TextContentEnterAnimation = keyframes`
  from {
    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  }

  to {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }
`

const TextContentLeaveAnimation = keyframes`
  from {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  }

  to {
    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  }
`

const NameEnterAnimation = keyframes`
  from {
    clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
  }

  to {
    clip-path: polygon(100% 0, 0 0, 0 100%, 100% 100%);
  }
`

const NameLeaveAnimation = keyframes`
  from {
    clip-path: polygon(100% 0, 0 0, 0 100%, 100% 100%);
  }

  to {
    clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);
  }
`

export const Container = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  --animation-duration: .8s;

  ${ArtCircle} {
    opacity: 0;
    animation-name: ${ArtCircleLeaveAnimation};
    animation-timing-function: ease;
    animation-duration: var(--animation-duration);
    animation-fill-mode: forwards;
  }

  &.isCurr {
    pointer-events: all;
    opacity: 1;

    ${ArtCircle} {
      opacity: 1;
      animation-name: ${ArtCircleEnterAnimation};
      animation-duration: var(--animation-duration);
      animation-delay: calc(var(--animation-duration) + 0.5s);
      animation-timing-function: ease;
      animation-fill-mode: forwards;
    }

    ${ArtCircle} {
      opacity: 1;
      clip-path: circle(0.0% at 50% 50%);
      transition: opacity ease var(--animation-duration) .5s;
    }

    ${ImageParallaxWrapper} {
      transform: translate(var(--translateX), var(--translateY));
    }

    ${NameLabel} {
      animation-name: ${NameEnterAnimation};
      animation-duration: var(--animation-duration);
      animation-timing-function: ease;
      animation-delay: var(--animation-duration);
      animation-fill-mode: forwards;
    }

    ${Label},
    ${Title},
    ${Text},
    ${Action} {
      animation-name: ${TextContentEnterAnimation};
      animation-duration: var(--animation-duration);
      animation-timing-function: ease;
      animation-delay: var(--animation-duration);
      animation-fill-mode: forwards;
    }
  }

  &.isBefore,
  &.isAfter,
  &.isPrev,
  &.isNext {

    ${Circle} {
      opacity: 0;
    }

    ${NameLabel} {
      animation-name: ${NameLeaveAnimation};
      animation-duration: var(--animation-duration);
      animation-timing-function: ease;
      animation-fill-mode: forwards;
    }

    ${Label},
    ${Title},
    ${Text},
    ${Action} {
      animation-name: ${TextContentLeaveAnimation};
      animation-duration: var(--animation-duration);
      animation-timing-function: ease;
      animation-fill-mode: forwards;
    }
  }

  /* bug fix on first render (bh#33) */

  &:not(.isCurr){
    ${Label},
    ${Title},
    ${Text},
    ${Action},
    ${NameLabel},
    ${ArtCircle} {
      opacity: 0;
    }
    ${ImageRotationWrapper}{
      transform: rotate(0deg);
    }
  }

  &.mounted:not(.isCurr){
    ${Label},
    ${Title},
    ${Text},
    ${Action},
    ${ArtCircle} {
      opacity: 1;
    }
    ${NameLabel}{
      opacity: .1;
    }
  }

  &:not(.mounted){
    ${ArtCircle} {
      animation: none;
    }
  }

  &.isLast{
    ${ImageRotationWrapper}{
      // transform: rotate(0deg);
    }
  }

`
